import { render, staticRenderFns } from "./DisclosureInvoice.vue?vue&type=template&id=3c1bdb8e&scoped=true&"
import script from "./DisclosureInvoice.vue?vue&type=script&lang=ts&"
export * from "./DisclosureInvoice.vue?vue&type=script&lang=ts&"
import style0 from "./DisclosureInvoice.vue?vue&type=style&index=0&id=3c1bdb8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1bdb8e",
  null
  
)

export default component.exports